import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import * as React from 'react';
//import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Backdrop, Box, Card, CardContent, CircularProgress, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText, Paper, Step, StepLabel, Stepper } from '@mui/material';
import Typography from '@mui/material/Typography';
import Api from '../api/Api';
//import logo from '../../public/shipped.png';
import moment from 'moment/moment';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { toast } from 'react-toastify';
import '../Custom.css';

import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

import LocationOnIcon from '@mui/icons-material/LocationOn';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    {/* <CloseIcon /> */}
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};



export default function CargoTrackingInfo(props) {
    const [open, setOpen] = React.useState(false);

    const [loading, setLoading] = React.useState(false)

    const [trackingNumber, setTrackingNumber] = React.useState("");
    const [sender, setSender] = React.useState("");
    const [receiver, setReceiver] = React.useState("");
    const [plannedDeliveryDate, setPlannedDeliveryDate] = React.useState("");
    const [arrivalDate, setArrivalDate] = React.useState("");
    const [cargoType, setCargoType] = React.useState("");
    const [arrivalAddress, setArrivalAddress] = React.useState("");
    const [info, setInfo] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [loadingCity, setLoadingCity] = React.useState("");
    const [lastStatus, setLastStatus] = React.useState("");
    const [unloadingCounty, setUnloadingCounty] = React.useState("");
    const [loadingCounty, setLoadingCounty] = React.useState("");
    const [stage, setStage] = React.useState("");
    const [orderDate, setOrderDate] = React.useState("")
    const [latitude, setLatitude] = React.useState("")
    const [longitude, setLongitude] = React.useState("")
    const [statuses, setStatuses] = React.useState([])
    const [no,setNo] = React.useState("");



    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        props.setShipmentNumber("")
    };

    const handleErrorClose = () => {
        toast.error("Sipariş Bulunamadı")
        setOpen(false);
    };



    const steps = [
        'Çıkışa Hazırlanıyor',
        'Yolda',
        'Teslim Edildi',
    ];

    const resolveActiveStep = (orderStatusCode, apiStage) => {
        const code = (orderStatusCode || '').toLowerCase();
        if (code === 'status_1') return 0;
        if (code === 'status_4') return 2;
        if (code) return 1;
        return Number(apiStage) || 0;
    };


    const loadCargoInfo = async (trackingNo) => {
        setLoading(true);

        var response = await Api.post('Tracking/track', {
            TrackingNo: trackingNo != null ? trackingNo : props.shipmentNumber 
        }).then(r => r.data).catch(console.error)
        if (response.statusCode == 200) {
            setSender(response.result.sender);
            setReceiver(response.result.receiver);
            setPlannedDeliveryDate(response.result.plannedDeliveryDate);
            setArrivalDate(response.result.arrivalTime);
            setCargoType(response.result.type)
            setArrivalAddress(response.result.unloadingCity)
            setUnloadingCounty(response.result.unloadingCounty)
            setInfo(response.result.information);
            setPhone(response.result.phone);
            setLoadingCity(response.result.loadingCity)
            setLoadingCounty(response.result.loadingCounty)
            setLastStatus(response.result.status)
            setStage(resolveActiveStep(response.result.orderStatusCode, response.result.stage))
            setOrderDate(response.result.orderDate)
            setStatuses(response.result.statuses)
            setLatitude(response?.result?.latitude)
            setLongitude(response?.result?.longitude)
            setNo(response.result.orderNo)

        }
        else (
            handleErrorClose()
        )

        setLoading(false)
    }


    React.useEffect(() => { if (open === true) loadCargoInfo() }, [open]);


    React.useEffect(() => {
        if (props.enterClick === true) {
           
            handleClickOpen()
            props.setEnterClick(false);
        }
        else if (props.enterClick === false) {
            props.setEnterClick(false);
        }
    }, [props.enterClick]);


    const position = [latitude ? latitude : "", longitude ? longitude : ""]

    const mapRef = React.useRef();

    const truckIcon = new Icon({
        iconUrl: "/blue.png",
        iconSize: [35, 35]
    })

    React.useEffect(() => {
        // Query parametrelerini almak için
        const queryParams = new URLSearchParams(window.location.search);
        const trackingNo = queryParams.get('trackingNo');
 
        if (trackingNo != null) {
            loadCargoInfo(trackingNo)
            handleClickOpen()
        }

    }, []);


    return (
        <div>
            <Button disabled={!props.shipmentNumber} sx={{ mt: 1 }} fullWidth variant="contained" onClick={handleClickOpen} id="searchButton">
                Sorgula
            </Button>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth={'xl'}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Takip No: {no}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>

                        <Backdrop sx={{ zIndex: theme => theme.zIndex.drawer + 1, backdropFilter: 'blur(10px)' }} open={loading}>
                            <CircularProgress sx={{ color: 'white' }} />
                        </Backdrop>

                        <Grid container spacing={1}>
                            <Grid item sm={12} xs={12}>
                                <Card elevation={3} sx={{ margin: 'auto', borderRadius: 3, p: 1 }} style={{ marginTop: 2, marginBottom: 20 }}>
                                    <CardContent>
                                        <Typography mt={4} >
                                            <Grid container spacing={2}>
                                                <Box sx={{ width: '100%' }}>
                                                    <Stepper activeStep={stage} alternativeLabel>
                                                        {steps.map((label) => (
                                                            <Step key={label}>
                                                                <StepLabel>{label}</StepLabel>
                                                            </Step>
                                                        ))}
                                                    </Stepper>
                                                </Box>

                                            </Grid>
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item sm={12} xs={12}>
                                <Card elevation={3} sx={{ margin: 'auto', borderRadius: 3, p: 1 }} style={{ marginTop: 2, marginBottom: 20 }}>
                                    <CardContent>
                                        <Typography mt={1} >
                                            <Grid container spacing={2}>
                                                <Grid item sm={6} xs={12} md={3}>
                                                    <Paper elevation={3} sx={{
                                                        display: 'flex',
                                                        '& > :not(style)': {
                                                            m: 1,
                                                            width: 250,
                                                            height: 170,
                                                        },
                                                    }} style={{ borderLeftStyle: "solid", borderLeftWidth: "15px", borderLeftColor: "#E97777", borderRadius: 15 }}>
                                                        <img src="/user.png" alt="Logo" id='IconLogo' />
                                                        <Grid container>
                                                            <Grid item sm={12} xs={12}>
                                                                <h3>Gönderici</h3>
                                                                <Divider />
                                                            </Grid>
                                                            <Grid item sm={12} xs={12}>
                                                                <Typography variant="subtitle2" gutterBottom style={{ fontSize: 18 }}>
                                                                    {sender}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                                <Grid item sm={6} xs={12} md={3}>
                                                    <Paper elevation={3} sx={{
                                                        display: 'flex',
                                                        '& > :not(style)': {
                                                            m: 1,
                                                            width: 250,
                                                            height: 170,
                                                        },
                                                    }} style={{ borderLeftStyle: "solid", borderLeftWidth: "15px", borderLeftColor: "#C9F4AA", borderRadius: 15 }}>
                                                        <img src="/warehouse.png" alt="Logo" id='IconLogo' />
                                                        <Grid container>
                                                            <Grid item sm={12} xs={12}>
                                                                <h3>Çıkış Yeri</h3>
                                                                <Divider />
                                                            </Grid>
                                                            <Grid item sm={12} xs={12}>
                                                                <Typography variant="subtitle2" gutterBottom style={{ fontSize: 18 }}>
                                                                    {/* {loadingCity + "/" + loadingCounty} */}
                                                                    {loadingCity} {loadingCounty}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                                <Grid item sm={6} xs={12} md={3}>
                                                    <Paper elevation={3} sx={{
                                                        display: 'flex',
                                                        '& > :not(style)': {
                                                            m: 1,
                                                            width: 250,
                                                            height: 170,
                                                        },
                                                    }} style={{ borderLeftStyle: "solid", borderLeftWidth: "15px", borderLeftColor: "#7F669D", borderRadius: 15 }}>
                                                        <img src="/calendar.png" alt="Logo" id='IconLogo' />
                                                        <Grid container>
                                                            <Grid item sm={12} xs={12}>
                                                                <h3>Planlanan Teslim Tarihi</h3>
                                                                <Divider />
                                                            </Grid>
                                                            <Grid item sm={12} xs={12}>
                                                                <Typography variant="subtitle2" gutterBottom style={{ fontSize: 18 }}>
                                                                    {plannedDeliveryDate == null ? "" : moment(plannedDeliveryDate).format('DD/MM/YYYY HH:mm')}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                                <Grid item sm={6} xs={12} md={3}>
                                                    <Paper elevation={3} sx={{
                                                        display: 'flex',
                                                        '& > :not(style)': {
                                                            m: 1,
                                                            width: 250,
                                                            height: 170,
                                                        },
                                                    }} style={{ borderLeftStyle: "solid", borderLeftWidth: "15px", borderLeftColor: "#FCC2FC", borderRadius: 15 }}>
                                                        <img src="/calendar.png" alt="Logo" id='IconLogo' />
                                                        <Grid container>
                                                            <Grid item sm={12} xs={12}>
                                                                <h3>Sipariş Tarihi</h3>
                                                                <Divider />
                                                            </Grid>
                                                            <Grid item sm={12} xs={12}>
                                                                <Typography variant="subtitle2" gutterBottom style={{ fontSize: 18 }}>
                                                                    {orderDate == null ? "" : moment(orderDate).format('DD/MM/YYYY HH:mm')}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                                <Grid item sm={6} xs={12} md={3}>
                                                    <Paper elevation={3} sx={{
                                                        display: 'flex',
                                                        '& > :not(style)': {
                                                            m: 1,
                                                            width: 250,
                                                            height: 170,
                                                        },
                                                    }} style={{ borderLeftStyle: "solid", borderLeftWidth: "15px", borderLeftColor: "#6096B4", borderRadius: 15 }}>
                                                        <img src="/user.png" alt="Logo" id='IconLogo' />
                                                        <Grid container>
                                                            <Grid item sm={12} xs={12}>
                                                                <h3>Alıcı</h3>
                                                                <Divider />
                                                            </Grid>
                                                            <Grid item sm={12} xs={12}>
                                                                <Typography variant="subtitle2" gutterBottom style={{ fontSize: 18 }}>
                                                                    {receiver}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                                <Grid item sm={6} xs={12} md={3}>
                                                    <Paper elevation={3} sx={{
                                                        display: 'flex',
                                                        '& > :not(style)': {
                                                            m: 1,
                                                            width: 250,
                                                            height: 170,
                                                        },
                                                    }} style={{ borderLeftStyle: "solid", borderLeftWidth: "15px", borderLeftColor: "#FAAB78", borderRadius: 15 }}>
                                                        <img src="/warehouse.png" alt="Logo" id='IconLogo' />
                                                        <Grid container>
                                                            <Grid item sm={12} xs={12}>
                                                                <h3>Teslim Yeri</h3>
                                                                <Divider />
                                                            </Grid>
                                                            <Grid item sm={12} xs={12}>
                                                                <Typography variant="subtitle2" gutterBottom style={{ fontSize: 18 }}>
                                                                    {/* {arrivalAddress + "/" + unloadingCounty} */}
                                                                    {arrivalAddress} {unloadingCounty}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                                <Grid item sm={6} xs={12} md={3}>
                                                    <Paper elevation={3} sx={{
                                                        display: 'flex',
                                                        '& > :not(style)': {
                                                            m: 1,
                                                            width: 250,
                                                            height: 170,
                                                        },
                                                    }} style={{ borderLeftStyle: "solid", borderLeftWidth: "15px", borderLeftColor: "#B5F1CC", borderRadius: 15 }}>
                                                        <img src="/calendar.png" alt="Logo" id='IconLogo' />
                                                        <Grid container>
                                                            <Grid item sm={12} xs={12}>
                                                                <h3>Teslim Tarihi</h3>
                                                                <Divider />
                                                            </Grid>
                                                            <Grid item sm={12} xs={12}>
                                                                <Typography variant="subtitle2" gutterBottom style={{ fontSize: 18 }}>
                                                                    {arrivalDate == null ? "" : moment(arrivalDate).format('DD/MM/YYYY HH:mm')}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                                <Grid item sm={6} xs={12} md={3}>
                                                    <Paper elevation={3} sx={{
                                                        display: 'flex',
                                                        '& > :not(style)': {
                                                            m: 1,
                                                            width: 250,
                                                            height: 170,
                                                        },
                                                    }} style={{ borderLeftStyle: "solid", borderLeftWidth: "15px", borderLeftColor: "#A7727D", borderRadius: 15 }}>
                                                        <img src="/info.png" alt="Logo" id='IconLogo' />
                                                        <Grid container>
                                                            <Grid item sm={12} xs={12}>
                                                                <h3>Durumu</h3>
                                                                <Divider />
                                                            </Grid>
                                                            <Grid item sm={12} xs={12}>
                                                                <Typography variant="subtitle2" gutterBottom style={{ fontSize: 18 }}>
                                                                    {lastStatus}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item sm={9} xs={12}  >
                                <Card elevation={3} sx={{ margin: 'auto', borderRadius: 3, p: 1 }}>
                                    <CardContent>
                                        <Typography mt={2} >
                                            <Grid container spacing={2}>
                                                <MapContainer center={[39, 36]} zoom={6} scrollWheelZoom={false} ref={mapRef} >
                                                    <TileLayer
                                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    />
                                                    <Marker position={[latitude ? latitude : "", longitude ? longitude : ""]} icon={truckIcon}>
                                                        {/* <Popup>
                                                            A pretty CSS3 popup. <br /> Easily customizable.
                                                        </Popup> */}
                                                    </Marker>
                                                </MapContainer>
                                            </Grid>
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item sm={3} xs={12} >
                                <Card elevation={3} sx={{ margin: 'auto', borderRadius: 3, p: 1 }}>
                                    <CardContent>
                                        <Typography mt={2} >
                                            <Grid container spacing={2}>
                                                <List
                                                    sx={{
                                                        width: '100%',
                                                        maxWidth: 360,
                                                        bgcolor: 'background.paper',
                                                    }}
                                                >
                                                    {statuses.map(item => {
                                                        return <>
                                                            <Divider variant="inset" component="li" />
                                                            <ListItem>
                                                                <ListItemAvatar>
                                                                    <Avatar>
                                                                        <LocationOnIcon />
                                                                    </Avatar>
                                                                </ListItemAvatar>
                                                                <ListItemText primary={item.name} secondary={moment(item.date).format('DD/MM/YYYY HH:mm') + " - " + item.branch + " - " + item.city + " / " + item.county} />
                                                            </ListItem>
                                                            <Divider variant="inset" component="li" />
                                                        </>
                                                    })}
                                                </List>
                                            </Grid>
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>    
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                        Kapat
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}